import { forwardRef } from 'react';
import { useUserContext } from 'src/contexts/UserContext';
import Profile from '../../img/profile.png';
import InspiniaAux from '../InspiniaAux';
import Dropdown from 'react-bootstrap/Dropdown';
import './style.css';
import styles from './styles.module.scss';

import TagManager from 'react-gtm-module';
import clsx from 'clsx';
import { supplierSupportWhatsappURL } from '../../utils/whatsapp';

const customToggle = forwardRef(({ children, onClick }, ref) => (
  <a
    ref={ref}
    href="/logout"
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

customToggle.displayName = 'customToggle';

function PortalNavBar({ className = '' }) {
  const { signOut, userData } = useUserContext();

  const userName = userData?.Account_Name || userData?.razao_social || '';

  const handleSignOut = e => {
    const event = {
      dataLayer: {
        event: 'user-logout',
        username: userName,
      },
    };
    TagManager.dataLayer(event);
    e.preventDefault();
    signOut();
  };

  const hideMenu = () => {
    const event = {
      dataLayer: {
        event: 'user-hide-menu',
        username: userName,
      },
    };
    TagManager.dataLayer(event);
  };

  return (
    <div className={clsx('row', className)}>
      <nav
        className={clsx(
          styles.navBar,
          'navbar navbar-static-top white-bg border-bottom',
        )}
        role="navigation"
      >
        <div className="navbar-header">
          <a
            className={clsx('navbar-minimalize  btn btn-warning text-white')}
            onClick={hideMenu}
          >
            <i className="fas fa-bars" />
          </a>
        </div>
        <InspiniaAux />
        <div className={clsx(styles.navBar__right, 'navbar-right')}>
          <div className="d-inline-block user-container mx-5 align-bottom">
            <p className="fw-bold m-0 d-md-inline-block d-none">{userName}</p>
            <a
              href="/"
              onClick={handleSignOut}
              className="btn btn-link text-right text-dark p-0 d-none d-md-block"
            >
              Sair
            </a>
          </div>
          <div className="d-inline-block logo-container ">
            <Dropdown>
              <Dropdown.Toggle
                as={customToggle}
                variant="success"
                className="logo-container"
                id="dropdown-basic"
              >
                <img
                  src={Profile}
                  className="rounded-circle w-100"
                  alt="Imagem do logo"
                />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>
                  <i className="fas fa-building " /> {userName}
                </Dropdown.Item>
                <Dropdown.Item
                  href={supplierSupportWhatsappURL}
                  target="_blank"
                  className="d-md-none"
                >
                  <i className="fab fa-whatsapp" /> Fale Conosco
                </Dropdown.Item>
                <Dropdown.Item onClick={handleSignOut}>Sair</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default PortalNavBar;
